import { produce } from 'immer';

import { ELEMENT_CHIP_SELECT, type ElementChipsAction } from './elementChipsActions';
import type { ElementChipSelection } from './elementChipsTypes';

export type ElementChipsState = {
    selectedChip: ElementChipSelection | null;
};

const initialState: ElementChipsState = {
    selectedChip: null,
};

/**
 * Stores transient generic chip selection state for toolbar-level consumers.
 */
const elementChipsReducer = (state = initialState, action: ElementChipsAction): ElementChipsState => {
    switch (action.type) {
        case ELEMENT_CHIP_SELECT:
            return produce(initialState, (draft) => {
                draft.selectedChip = action.selection;
            });
        default:
            return state;
    }
};

export default elementChipsReducer;
